import { render } from "./FifthStep.vue?vue&type=template&id=5af1fa98&scoped=true"
import script from "./FifthStep.vue?vue&type=script&lang=js"
export * from "./FifthStep.vue?vue&type=script&lang=js"

import "./FifthStep.vue?vue&type=style&index=0&id=5af1fa98&lang=scss&scoped=true"

import exportComponent from "/Users/dawndo/bestphone/main_apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af1fa98"]])

export default __exports__